import React, { useState } from 'react'
import { DataContext } from '../../../helper/HelperOne'
import NavBar from '../../nav_bar/Navbar'
import CityList from './CityList'

function City() {
    const [searchUi, setSearchUi] = useState(false)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<CityList/>}
                menuId={6}
            />
        </DataContext.Provider>
    )
}

export default City